export default   {
    search: '',
    suggestions: [],
    selectedZip: null,
    showSuggestions: false,
    debounceTimeout: null,
    barvalue: 33.333333333,
    barmax: 50,
    month_debs:'',
    oldData:null,
    creditDebtPayment : null,
    studentLoan : null,
    alimonyPayments : null,
    homeEquityPayment : null,
    childSupportPayments : null,
    estimatedTaxPayments : null,
    otherDebtPayments : null,
    investmentBalanceFixed : false,
    investmentBalance : '$0',
    fill: { gradient: ["blue", "blue", "blue"] },
    net_amount: [
      {
        amount: "",
        freq: 12,
        manual: "2",
        occupation: null,
        level: 1,
        area: 2,
        grossOrNet: "net",
        net: 0,
        gross: 0,
      },
    ],
    area_level: [
      { text: "Area", value: 1 },
      { text: "State", value: 2 },
      { text: "USA", value: 3 },
    ],
    auth: {},
    value: 1,
    data: [
      {
        id: 1,
        name: "1",
      },
      {
        id: 2,
        name: "2",
      },
      {
        id: 3,
        name: "3",
      },
      {
        id: 4,
        name: "4",
      },
      {
        id: 5,
        name: "5+",
      },
    ],
    dropdownOpen: false,
    dotOptions: [],
    searchText:'',
    predictGrowth: "6.0",
    selected: "first",
    grossOrNet: "gross",
    home_options: [
      { text: "Renter", value: false },
      { text: "Owner", value: true },
    ],
    income_method_val: false,
    income_method: [
      { text: "Occupation", value: "1" },
      { text: "Manual Input", value: "2" },
    ],
    occupations_val: null,
    annual_gross_salary_level_val: 0,
    annual_gross_salary_level: [
      { text: "Low/Entry", value: 1 },
      { text: "25th Percentile", value: 2 },
      { text: "Median", value: 3 },
      { text: "75th Percentile", value: 4 },
      { text: "High/Experienced", value: 5 },
    ],
    dark: true,
    page: "main",
    hideBarChart: true,
    cancelToken: undefined,
    netAmount: 0,
    occupations: [],
    savingEdit: false,
    visibleResultsSummary: false,
    visibleYourHousehold: false,
    visibleCoreExp: false,
    visibleCustCoreExp: false,
    visibleVhCustCoreExp: false,
    visibleDbtCustCoreExp: false,
    visibleSvAmtCoreExp: false,
    visiblePersComp: false,
    visibleCoreExpCat: false,
    visibleProfileHousehold: true,
    visibleOtherExpCat: false,
    visibleCommonBillsCat: false,
    visibleMonthlyBillsCat: false,
    visibleDisabledCat: false,
    visibleResultDetails: false,
    visibleYourBudget: false,
    visibleYourPeers: false,
    visibleCashHealthAnalysis: true,
    visibleFAQ: false,
    visibleFaqOne: false,
    visibleFaqTwo: false,
    visibleFaqThree: false,
    visibleFaqFour: false,
    visibleFaqFive: false,
    visibleFaqSix: false,
    visibleFaqSeven: false,
    visibleFaqEight: false,
    visibleFaqNine: false,
    visibleFaqTen: false,
    visibleFaqEleven: false,
    visibleFaqTwelve: false,
    visibleFaqThirteen: false,
    visibleFaqFourteen: false,
    visibleFaqFifteen: false,
    visibleModalPieChart: false,
    info_hover: false,
    visible: true,
    sortBy: "",
    sortType: "",
    isHidden: true,
    checked: true,
    chart: null,
    chart_range: "month",
    is_typing: false,
    api_updates_pending: false,
    active_persona_index: 0,
    collapsedChecked: false,
    money: {
      decimal: ".",
      thousands: ",",
      prefix: "$",
      suffix: "",
      precision: "0",
      masked: false,
    },
    budget: null,
    demographics_response: null,
    scores: null,
    lending_score: null,
    pie_chart: null,
    pie_chart2: null,
    pie_chart3: null,
    pie_chart4: null,
    pie_chart5: null,
    speed_chart: null,
    bar_chart: null,
    barChart: null,
    peers_input_value: null,
    filtered_barchart: null,
    savings_input_value: null,
    savings_input_value_freq: 12,
    mortgage_and_rent_input_value: null,
    mortgage_and_rent_input_value_freq: 12,
    vehicle_purchase_and_lease_input_value: null,
    vehicle_purchase_and_lease_input_value_freq: 12,
    health_insurance_input_value: null,
    health_insurance_input_value_freq: 12,
    debt_input_value: null,
    debt_input_value_freq: 12,
    peer_income: "--",
    // monthly_take_home_input_value: "",
    monthly_take_home_input_value_freq: 12,
    age: [""],
    household_members: "1",
    occupationGrossIncome: "0",
    // zip: "",
    zipCode: null,
    selectedZip: null,
    is_homeowner: false,
    filter_cateory: "",
    selected_category: "transformer_24",
    budgetFilter: null,
    peerFilter: null,
    differenceFilter: null,
    frequencyOptions: [
      { text: "Monthly", value: 12 },
      { text: "Weekly", value: 52 },
      { text: "Quarterly", value: 4 },
      { text: "Semi-Annually", value: 2 },
      { text: "Annually", value: 1 },
    ],
    frequencyOptionsNew: [
      { text: "Weekly", value: 52 },
      { text: "Every 2 Weeks", value: 26 },
      { text: "Twice per Month", value: 24 },
      { text: "Monthly", value: 12 },
      { text: "Quarterly", value: 4 },
      { text: "Semi-Annually", value: 2 },
      { text: "Annually", value: 1 },
    ],
    changedValues: {},
    changedValuesText: {},
    defaultSelectedEliminationName: "",
    eliminated: {},
    sortDefault: true,
    gridFirst: false,
    gridSecond: true,
    gridThird: false,
    showPeer: true,
    chart3Data: [],
    chart4Data: [],
    isActive: true,
    percentage: 0,
    apiReq: null,
    callDemographicsAPIRes: null,
    callBudgetAPIRes: null,
    callScoringAPIRes: null,
    callLendingScoreAPIRes: null,
    dataSent: null,
    useCase: null,
    defaultUseCase: null,
    defaultEducation: null,
    loginLoading: false,
    user_name: "",
    user_email: "",
    user_password: "",
    otp: "",
    verifyEnable: true,
    verifyMsg: "",
    stepEnable: false,
    byPass: false,
    key: "hCqpmeIgXhrnRnMwAanDT2qqocZDUtQ1yTZHUkle",
    activeTab: ["Your Profile"],
    showYourResultsTab: true,
    userActivityTimeout: null,
    activeLink: "",
    user_email_pdf: "",
    modalShow: false,
    uses: "",
    defaultActiveTab: "",
    saveReportPopUp: false,
    demographicsCached: null,
    budgetCached: null,
    scoresCached: null,
    lendingScoreCached: null,
    occupationAILoad: false,
    occupationAIText: [],
    openSidebar:false,
    billSectionShow:false,
    imageUrl: '',
    inDemo:false
  };